import { useState, useEffect } from 'react';
import { supabase } from './storage';
import Login from './Login';
import CRM from './CRM';

export default function App() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!supabase) {
      // Supabase not configured - show login which will show error
      setChecking(false);
      return;
    }

    supabase.auth.getUser().then(({ data: { user } }) => {
      setUser(user);
      setChecking(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setUser(session?.user || null);
      }
    );

    return () => subscription.unsubscribe();
  }, []);

  const handleLogin = (user) => setUser(user);

  const handleLogout = async () => {
    if (supabase) await supabase.auth.signOut();
    setUser(null);
  };

  if (checking) {
    return (
      <div style={{
        minHeight: '100vh', background: '#0F0F13',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: '#E91E90', fontFamily: "'Outfit', sans-serif", fontSize: 20,
      }}>
        <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@700&display=swap" rel="stylesheet"/>
        Indlæser...
      </div>
    );
  }

  if (!user) return <Login onLogin={handleLogin} />;

  return <CRM onLogout={handleLogout} />;
}
